import React, { useEffect, useState } from 'react';
import Agent from "../../../Network/Agent";
import {useLocation, useNavigate} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import {Spinner} from "react-bootstrap";
import {getStoreName} from "../../../Components/Utils/getStoreName";
import ToolBar from "../../../Components/Elements/ToolBar";
import SpinnerCustom from "../../../Components/ui/SpinnerCustom";
import ButtonPrimary from "../../../Components/Elements/ButtonPrimary";

const Guilds = () => {
    const storeUsernameInUrl = getStoreName()
    const [selectedGuildCode, setSelectedGuildCode] = useState('');
    const [buttonLoading, setButtonLoading] = useState(false);

    const navigate = useNavigate()
    const location = useLocation()
    const {guildCode} = location.state

    const {data: guilds, isLoading: isLoadingGuilds} = useQuery({
        queryKey: ['guilds' , storeUsernameInUrl],
        queryFn: async () => {
            const response = await Agent.Guild.getList()
            const { guilds } = response.data.result
            return guilds
        }
    })

    const onSubmitGuild = () => {
        setButtonLoading(true);
        Agent.Store.updateGuild(storeUsernameInUrl, selectedGuildCode)
            .then(response => {
                setButtonLoading(false);
                navigate(-1)
            })
            .catch(error => {
                console.log(error.response);
                setButtonLoading(false);
            });
    };

    return (
        <>
            <ToolBar title="انتخاب نوع خدمت/کالا" navigate={() => navigate(-1)} />

            <section className=''>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='mobile-subtitle-regular cl-subtitle mt-8'>
                                لطفا نوع خدمت و یا کالای خود را انتخاب کنید:
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='mt-12'>
                                {
                                    isLoadingGuilds &&
                                        <SpinnerCustom className="pt-96">
                                            <Spinner
                                                className={'custom-spinner d-inline-block'}
                                                style={{ color: "#000", width: '36px', height: '36px' }}
                                                animation="border" />
                                        </SpinnerCustom>
                                }
                                {
                                    !isLoadingGuilds &&
                                        guilds.map(guild => (
                                            <div key={guild.code} className='form-group-select-row-radio pt-12'>
                                                <label className="form-group-label cursor-pointer">
                                                    <input
                                                        type="radio"
                                                        name='guild'
                                                        onChange={() => setSelectedGuildCode(guild.code)}
                                                        defaultChecked={guildCode === guild.code}
                                                        className='form-group-input'
                                                    />
                                                    <div className='label-view'>
                                                        <div className='d-flex align-items-center justify-content-between'>
                                                            <div className='mobile-h5 cl-black mt-custom-4'>
                                                                {guild.title}
                                                            </div>
                                                            <div className='round-tick'>
                                                                <img src={"/assets/images/vectors/tick_blue.svg"} alt="tick"/>
                                                            </div>
                                                        </div>
                                                        <div className='divider-1px bg-gray-custom-1 mt-16' />
                                                    </div>
                                                </label>
                                            </div>
                                        ))
                                }
                            </div>
                        </div>
                        <div className='btn-fixed-bottom'>
                            <div onClick={onSubmitGuild}>
                                <ButtonPrimary mode='dark-mode' text='ثبت' isLoading={buttonLoading} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='scroll-fixer'></div>
            </section>
        </>
    );
};

export default Guilds;
